import * as React from 'react';
import * as classNames from 'classnames';
import {ReactElement, Component  } from 'react';
import {VideoSettingsLabel as Label} from '../label/label';
import {Select, ISelectOption} from '../../select/select';
import {IHTMLAudioElement, IAudioOutput, IDevice} from '../../../redux/modules/video-settings';
import {
  DOES_NOT_SUPPORT_CHOOSING_SOUND_OUTPUT,
  AUDIO_OUTPUT_EMPTY,
} from './constants';
import './styles.sass';

export interface IVideoSettingsSoundOutputProps {
  isSetSinkIdSupported: boolean;
  audioOutputDeviceId: string;
  audioOutputDevices: Array<IDevice>;
  audioOutputError: string;
  selectAudioOutput?: (props: IAudioOutput) => void;
}

interface IState {
  isPlaying?: boolean;
}

export class VideoSettingsSoundOutput extends Component<IVideoSettingsSoundOutputProps, IState> {
  public state: IState = {
    isPlaying: false,
  };

  private audioElement: IHTMLAudioElement;

  public render(): ReactElement<any> {
    const {
      isSetSinkIdSupported,
      audioOutputDeviceId,
      audioOutputDevices,
      audioOutputError,
    } = this.props;

    const {isPlaying} = this.state;

    const isEmpty: boolean = audioOutputDevices.length <= 0;
    const isVisible: boolean = !isEmpty && isSetSinkIdSupported;
    const disabled: boolean = isPlaying;

    return (
      <div className={'video-settings-sound-output'}>
        <Label>
          Sound Output

          {isVisible && (
            <span
              className={
                classNames('video-settings-sound-output__test', {
                  'video-settings-sound-output__test_active': isPlaying,
                })
              }
              onClick={this.onPlay}
            >
              <audio
                ref={this.setAudioElement}
                src={require('../../../assets/mp3/peer-joined.mp3')}
              />

              {isPlaying ? 'Playing...' : 'Play a sound'}
            </span>
          )}
        </Label>

        {isVisible ? (
          <Select
            disabled={disabled}
            options={audioOutputDevices}
            value={audioOutputDeviceId}
            error={audioOutputError}
            onChange={this.onChange}
          />
        ) : (
          <div className={'video-settings-sound-output__message'}>
            {(isSetSinkIdSupported && isEmpty) ? AUDIO_OUTPUT_EMPTY : DOES_NOT_SUPPORT_CHOOSING_SOUND_OUTPUT}
          </div>
        )}
      </div>
    );
  }

  public componentDidMount(): void {
    if (this.props.isSetSinkIdSupported) {
      this.audioElement.addEventListener('playing', this.onPlaying, false);
      this.audioElement.addEventListener('ended', this.onEnded, false);
      this.assignDevice();
    }
  }

  public componentWillUnmount(): void {
    if (this.props.isSetSinkIdSupported) {
      this.audioElement.removeEventListener('playing', this.onPlaying);
      this.audioElement.removeEventListener('ended', this.onEnded);
    }
  }

  private onPlay = () => (
    this.audioElement.play()
  )

  private onPlaying = () => (
    this.setState({isPlaying: true})
  );

  private onEnded = () => (
    this.setState({isPlaying: false})
  );

  private onChange = ({value: audioOutputDeviceId}: ISelectOption) => (
    this.props.selectAudioOutput({element: this.audioElement, audioOutputDeviceId})
  );

  private setAudioElement = (node: IHTMLAudioElement) => {
    this.audioElement = node;
  }

  private assignDevice = () => {
    const {audioOutputDeviceId, audioOutputDevices} = this.props;

    const deviceExists: boolean = !!audioOutputDevices
      .find(({value: deviceId}) => deviceId === audioOutputDeviceId);

    if (deviceExists) {
      this.audioElement.setSinkId(audioOutputDeviceId);
    }
  }
}
